import { cn } from "@/lib/cn";
import { formatPrice } from "@/lib/format";
import { useSiteSettings } from "@/hooks/use-site-settings";

// One-time vs Subscribe & Save 15% toggle.
export function SubscribeToggle({
  isSubscription,
  oneTimePrice,
  subscribePrice,
  onChange,
}: {
  isSubscription: boolean;
  oneTimePrice: number;
  subscribePrice: number;
  onChange: (sub: boolean) => void;
}) {
  // DRB-38: gated INSIDE the component rather than at the call site, so the feature cannot
  // reappear through a caller someone adds later. Same reason for the sibling components.
  const { settings } = useSiteSettings();
  if (settings.subscriptionsEnabled !== true) return null;

  return (
    <div className="grid gap-2">
      <button
        type="button"
        onClick={() => onChange(false)}
        className={cn(
          "flex items-center justify-between rounded-card border-2 p-3 text-left transition-colors",
          !isSubscription
            ? "border-leaf-green bg-leaf-green/5"
            : "border-night-blue/15",
        )}
      >
        <span className="flex items-center gap-2">
          <span
            className={cn(
              "h-4 w-4 rounded-full border-2",
              !isSubscription
                ? "border-leaf-green bg-leaf-green"
                : "border-night-blue/30",
            )}
          />
          <span className="text-sm font-medium text-night-blue">
            One-time purchase
          </span>
        </span>
        <span className="font-condensed font-bold text-night-blue">
          {formatPrice(oneTimePrice)}
        </span>
      </button>

      <button
        type="button"
        onClick={() => onChange(true)}
        className={cn(
          "flex items-center justify-between rounded-card border-2 p-3 text-left transition-colors",
          isSubscription
            ? "border-leaf-green bg-leaf-green/5"
            : "border-night-blue/15",
        )}
      >
        <span className="flex items-center gap-2">
          <span
            className={cn(
              "h-4 w-4 rounded-full border-2",
              isSubscription
                ? "border-leaf-green bg-leaf-green"
                : "border-night-blue/30",
            )}
          />
          <span>
            <span className="block text-sm font-medium text-night-blue">
              Subscribe &amp; Save
            </span>
            <span className="block text-xs text-leaf-green-ink">
              Save 15% + free shipping · skip anytime
            </span>
          </span>
        </span>
        <span className="font-condensed font-bold text-leaf-green-ink">
          {formatPrice(subscribePrice)}
        </span>
      </button>
    </div>
  );
}
